<dx-check-box #dx [value]="value()" [enableThreeStateBehavior]="false" [disabled]="disabled()" [readOnly]="readonly()" (onValueChanged)="onValueChanged($event)"
  (onBlur)="onBlur($event)"></dx-check-box>

<!-- dxCheckBox only renders a hidden input, so this labelable proxy carries the id an external label[for] points at -->
<input class="label-proxy" type="checkbox" tabindex="-1" aria-hidden="true" [attr.id]="inputId()" [checked]="value()"
  [disabled]="disabled() || readonly()" (change)="toggleFromLabel()">
